
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/closeio",
      function () {
        return require("private-next-pages/destinations/closeio.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/closeio"])
      });
    }
  